/**
 * HostedCard — a page's own card, unless the page is shown as a tab of a host page.
 *
 * Standing alone it is the page card with its header (title) and action (extra). Hosted — the
 * Shifts workspace shows four screens under its own tabs — the host already has the card and the
 * header, so this renders only the content and the page puts its header action through
 * `HeaderActions`.
 */
import React from 'react';
import { Card } from 'antd';

export default function HostedCard({ hosted = false, title, extra, children, ...rest }) {
  if (hosted) return <>{children}</>;
  return (
    <Card className="m-2.5 border border-gray-300 shadow-md" title={title} extra={extra} {...rest}>
      {children}
    </Card>
  );
}
